import uri from './uri';
import ajax from './ajax.jquery';

let source = uri.getQuery('source');
let account = {
  sourceMap: {},
  convert_map: {},
};
let currentAccount = null;

export function toutiaoPush() {
  if (window._taq && currentAccount) {
    _taq.push(currentAccount);
  } else {
    return;
  }

};
export function requestToutiao(requestToutiaoJsonUrl) {
  if (source) {
    ajax.get(requestToutiaoJsonUrl).then((response) => {
      let json = response;
      if (json && json.sourceMap) {
        account = json;
        toutiaoInit();
      }
    });
  }
}

function toutiaoInit() {
  let group = account.sourceMap[source];
  if (group) {
    currentAccount = account.convert_map[group];
    window._tt_config = true;
    let ta = document.createElement('script');
    ta.type = 'text/javascript';
    ta.async = true;
    ta.src = document.location.protocol + '//' + 's3.pstatp.com/bytecom/resource/track_log/src/toutiao-track-log.js';
    ta.onerror = function() {
      let request = new XMLHttpRequest();
      let web_url = window.encodeURIComponent(window.location.href);
      let js_url = ta.src;
      let url = '//ad.toutiao.com/link_monitor/cdn_failed?web_url=' + web_url + '&js_url=' + js_url + '&convert_id=' + currentAccount.convert_id;
      request.open('GET', url, true);
      request.send(null);
    };
    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ta, s);
  }
}



export default {toutiaoPush, requestToutiao};



// WEBPACK FOOTER //
// ./src/component/common/toutiao.js